module.exports = __webpack_public_path__ + "media/images/watch/study_tools-7206402c4c8cb90169eede53ad4fe681.png";